import { createSlice } from '@reduxjs/toolkit'

import { schedulePageSelectors } from '../selectors/schedulePage'

const initialState = {
    dateFrom: '',
    dateTo: '',
    viewMode: 'group',
    selectedGroupId: '',
    selectedTeacherId: '',
    selectedRoomId: '',
    selectedBuildId: '',
    selectedClassTypeId: '',
    selectedSubjectId: '',
    selectedExportGroupId: '',
    selectedExportGroupName: '',
    exportModalOpen: false,
    error: '',
    saveOnServer: false,
    currentPage: 1,
    pageSize: 15,
    showMoreOptions: false,
}

const schedulePage = createSlice({
    name: 'schedulePage',
    initialState,
    reducers: {
        setDateFrom: (state, action) => {
            state.dateFrom = action.payload
        },
        setDateTo: (state, action) => {
            state.dateTo = action.payload
        },
        clearDateFilter: (state) => {
            state.dateFrom = ''
            state.dateTo = ''
        },
        setDateRange: (state, action) => {
            state.dateFrom = action.payload.dateFrom
            state.dateTo = action.payload.dateTo
            state.currentPage = 1
        },
        setViewMode: (state, action) => {
            state.viewMode = action.payload
            state.error = ''
            state.currentPage = 1
        },
        setSelectedGroupId: (state, action) => {
            state.selectedGroupId = action.payload
            state.currentPage = 1
        },
        setSelectedTeacherId: (state, action) => {
            state.selectedTeacherId = action.payload
            state.currentPage = 1
        },
        setSelectedRoomId: (state, action) => {
            state.selectedRoomId = action.payload
            state.currentPage = 1
        },
        setSelectedBuildId: (state, action) => {
            state.selectedBuildId = action.payload
            state.selectedRoomId = ''
            state.currentPage = 1
        },
        setSelectedClassTypeId: (state, action) => {
            state.selectedClassTypeId = action.payload
            state.currentPage = 1
        },
        setSelectedSubjectId: (state, action) => {
            state.selectedSubjectId = action.payload
            state.currentPage = 1
        },
        setExportGroup: (state, action) => {
            state.selectedExportGroupId = action.payload.groupId
            state.selectedExportGroupName = action.payload.groupName
        },
        setExportModalOpen: (state, action) => {
            state.exportModalOpen = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setSaveOnServer: (state, action) => {
            state.saveOnServer = action.payload
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload
            state.currentPage = 1
        },
        setPagination: (state, action) => {
            state.currentPage = action.payload.page
            if (action.payload.pageSize !== undefined) {
                state.pageSize = action.payload.pageSize
                state.currentPage = 1
            }
        },
        toggleShowMoreOptions: (state) => {
            state.showMoreOptions = !state.showMoreOptions
        },
        resetFilters: (state) => {
            state.selectedRoomId = ''
            state.selectedClassTypeId = ''
            state.selectedSubjectId = ''
            state.selectedBuildId = ''
        },
        resetPage: () => initialState,
    },
    selectors: {
        ...schedulePageSelectors,
    },
})

export const schedulePageSelector = schedulePage.getSelectors()
export const schedulePageActions = schedulePage.actions

export default schedulePage.reducer
